import { ThemeOptions } from "@mui/material";
import { typographyVariants } from "../constants";

export const muiListItemText: ThemeOptions["components"] = {
  MuiListItemText: {
    styleOverrides: {
      primary: ({ theme }) => ({
        ...typographyVariants.body,
        color: theme.palette.typography.listItem?.primary,
      }),
      secondary: ({ theme }) => ({
        ...typographyVariants.body,
        color: theme.palette.typography.listItem?.secondary,
      }),
    },
  },
};
